/**
 * Bridge between the v2 class Overview tab and the still-legacy single-student page.
 *
 * The Overview is Flux-free (its subject scope lives in React state via useClassOverview), but the
 * single-student page reads its subject filter from the legacy TeacherClassroomScope store, which
 * defaults to the first subject. Without this, clicking a student off the Overview drops you onto
 * that page scoped to the first subject instead of the subject you were looking at.
 *
 * The Overview records its current subject selection here; TeacherClassroomScope.store reads it to
 * choose the subject dropdown's active option. Session-scoped (a plain in-memory map) — it carries
 * the selection across SPA navigation and resets on a full reload, which matches the legacy filter.
 */
const overviewSubjectScopeByClassroom = new Map<string, string[]>();

/** v2 subject scope: `[]` means "All Subjects", `[id]` a single subject (mirrors OverviewScope). */
export const setOverviewSubjectScope = (classroomId: string, subjectIds: string[]): void => {
  overviewSubjectScopeByClassroom.set(classroomId, subjectIds);
};

/**
 * The legacy subject-dropdown option id the single-student page should open on for this classroom,
 * or `null` when the Overview hasn't recorded a selection (caller keeps its own default).
 */
export const getOverviewActiveSubjectOptionId = (classroomId: string): string | null => {
  const subjectIds = overviewSubjectScopeByClassroom.get(classroomId);
  if (!subjectIds) {
    return null;
  }
  return subjectIds.length === 0 ? 'all-subjects' : subjectIds[0];
};
